exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3hHG1rH3ODpZPM{display:flex;flex-direction:row;align-items:center;margin:0}._3bThrzYr4rMCw7{flex-grow:1;font-size:14px;line-height:24px;padding-right:25px}._3TcdbJZ-56NfN8{margin:0 0 0 20px;flex-shrink:0}._3TcdbJZ-56NfN8 button{margin-top:0;margin-right:0;cursor:pointer}._3TcdbJZ-56NfN8 button:hover{background-color:#c1c7d0}._3TcdbJZ-56NfN8 button:active{background-color:#b3bac5;color:#172b4d}", ""]);

// exports
exports.locals = {
	"noticeBannerContainer": "_3hHG1rH3ODpZPM",
	"textContent": "_3bThrzYr4rMCw7",
	"learnMoreButton": "_3TcdbJZ-56NfN8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/notice-banner/notice-banner.less
// module id = jyZ7
// module chunks = 24